import gql from "graphql-tag";

export const CURRENT_AUTOMATION_STATUS_QUERY = gql`
  query {
    currentAutomationStatus {
      id
      description
      status
      autoGenerated
      insertedAt
      url
    }
  }
`;

export const LIST_AUTOMATION_STATUS_QUERY = gql`
  query {
    listAutomationStatus {
      id
      description
      insertedAt
      autoGenerated
      status
    }
  }
`;

// Selects the same fields as CURRENT_AUTOMATION_STATUS_QUERY so the payload can
// be written straight into that query's cache entry. A single backend poller
// (AutomationStatusPoller) publishes on change, replacing per-client polling.
export const SUBSCRIBE_TO_AUTOMATION_STATUS = gql`
  subscription {
    subscribeToAutomationStatus {
      id
      description
      status
      autoGenerated
      insertedAt
      url
    }
  }
`;
